import { InsuranceExpirationInput } from 'app/home/create-quote/forms/insurance-expiration/insurance-expiration.types';
import type { QuoteDraftSelectorState } from 'app/home/global-store/quote-draft';

export function insuranceExpirationQuoteFormSelector(store: QuoteDraftSelectorState): InsuranceExpirationInput {
  const isInsuranceExpiredMoreThan30Days = store.isInsuranceExpiredMoreThan30Days();
  return { isInsuranceExpiredMoreThan30Days };
}
